import { render, staticRenderFns } from "./AuthorBox.vue?vue&type=template&id=70167624&scoped=true&"
import script from "./AuthorBox.vue?vue&type=script&lang=js&"
export * from "./AuthorBox.vue?vue&type=script&lang=js&"
import style0 from "./AuthorBox.vue?vue&type=style&index=0&id=70167624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70167624",
  null
  
)

export default component.exports